<template>
  <b-container>
    <b-row>
      <h2>{{ $t("scheduler.schedules") }}</h2>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <br />
    <!-- <base-detailed-filter> </base-detailed-filter> -->
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <div v-if="tableFilters[field.filterKey] != null">
                <b-form-input
                  type="date"
                  v-if="field.key == 'dateScheduler'"
                  v-model="tableFilters[field.key]"
                />
                <b-form-select
                  v-else-if="field.key == 'status'"
                  v-model="tableFilters[field.key]"
                  :options="statusOption"
                />
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <router-link
            v-if="isSchedulerEditable(data.item)"
            class="desktop-buttons"
            :to="getUrlEdit(data.item)"
          >
            <b-button size="sm" class="btn-checklist">{{
              $t("geral.edit")
            }}</b-button>
          </router-link>
          <router-link
            v-else
            class="desktop-buttons"
            :to="getUrlEdit(data.item)"
          >
            <b-button size="sm" class="btn-checklist">{{
              $t("geral.detalhes")
            }}</b-button>
          </router-link>

          <b-button
            v-if="isSchedulerActive(data.item)"
            size="sm"
            class="btn-checklist ml-2"
            @click="schedulerDeactivate(data.item)"
            >{{ $t("geral.delete") }}</b-button
          >
          <b-button
            v-else
            size="sm"
            class="btn-checklist ml-2"
            @click="schedulerActivate(data.item)"
            >{{ $t("geral.activate") }}</b-button
          >
        </template>
        <template v-slot:cell(ativo)="data">
          {{ data.value ? "Sim" : "Não" }}
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>
      <b-col>
        <label for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}</label
        >
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-select
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            />
          </b-col>
          <b-col>
            <label for="perPageSelect">Registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "FormSchedules",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "schedulerId",
          filterKey: "id",
          sortable: false,
          label: "Agendamento",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "description",
          filterKey: "description",
          label: "Descrição",
          sortable: true,
        },
        {
          key: "formName",
          filterKey: "formName",
          label: "Formulário",
          sortable: true,
        },
        {
          key: "status",
          filterKey: "status",
          label: "Status",
          sortable: true,
        },

        {
          key: "dateNextScheduler",
          filterKey: "dateNextScheduler",
          label: "Próximo agendamento",
          sortable: true,
          formatter: (value, key, item) => {
            let date = new Date(value);
            return date.toLocaleDateString();
          },
        },
        // {
        //   key: "status",
        //   filterKey: "status",
        //   label: "Status",
        //   sortable: true
        // },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      statusOption: [
        { value: 1, text: "Em aberto" },
        { value: 2, text: "Finalizado" },
        { value: 3, text: "Inativos" },
      ],
      tableFilters: {
        schedulerChecklistId: "",
        formName: "",
        description: "",
        dateScheduler: "",
        searchKeyValue: "",
        status: 1,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      filterApplied: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    getUrlEdit(scheduler) {
      console.log(scheduler);
      return `/checklist/scheduler/edit/${scheduler.schedulerId}`;
    },
    getUrlFilledDetails(scheduler) {
      return "/checklist/form/filled/details/" + scheduler.checklistId;
    },
    isSchedulerActive(scheduler) {
      if (scheduler) {
        return scheduler.active;
      }
      return false;
    },
    isSchedulerEditable(scheduler) {
      console.log(`scheduler: ${scheduler}`);
      if (!this.isSchedulerActive(scheduler)) {
        return false;
      }
      if (!scheduler) {
        return false;
      }
      if (scheduler.isInUse) {
        return false;
      }
      return true;
    },
    myProvider(ctx) {
      this.isBusy = true;
      let status = null;
      if (ctx.filter.status == 1) status = "Em aberto";
      else if (ctx.filter.status == 2) status = "Finalizado";
      else if (ctx.filter.status == 3) status = "Inativo";
      else status = "";
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        schedulerChecklistId: ctx.filter.schedulerChecklistId,
        formName: ctx.filter.formName,
        description: ctx.filter.description,
        dateScheduler: ctx.filter.dateScheduler,
        searchKeyValue: ctx.filter.searchKeyValue,
        status: status,
      };
      console.log(apiParam);
      return this.$apiChecklist
        .post("/schedulers/all", apiParam)
        .then((response) => {
          const items = response.data.items;
          // console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    schedulerActivate(scheduler) {
      this.$apiChecklist
        .get("/scheduler/activate/" + scheduler.schedulerId.toString())
        .then((response) => {
          scheduler.active = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    schedulerDeactivate(scheduler) {
      this.$apiChecklist
        .get("/scheduler/deactivate/" + scheduler.schedulerId.toString())
        .then((response) => {
          scheduler.active = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

<style scoped>
.btn-checklist {
  min-width: 95px;
}
</style>